"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * This is not tested! Use at your own risk.
 */
function useDebounce(value, timeout) {
    var _a = React.useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    React.useEffect(function () {
        var handler = setTimeout(function () { return setDebouncedValue(value); }, timeout);
        return function () { return clearTimeout(handler); };
    }, [value, timeout]);
    return debouncedValue;
}
exports.useDebounce = useDebounce;
//# sourceMappingURL=useDebounce.js.map